/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface SalesTabData
 */
export interface SalesTabData {
  /**
   *
   * @type {string}
   * @memberof SalesTabData
   */
  monthName: string;
  /**
   *
   * @type {number}
   * @memberof SalesTabData
   */
  year: number;
  /**
   *
   * @type {number}
   * @memberof SalesTabData
   */
  revenue: number;
  /**
   *
   * @type {number}
   * @memberof SalesTabData
   */
  profit: number;
  /**
   *
   * @type {number}
   * @memberof SalesTabData
   */
  bookedShipments: number;
  /**
   *
   * @type {number}
   * @memberof SalesTabData
   */
  quotesRan: number;
  /**
   *
   * @type {number}
   * @memberof SalesTabData
   */
  quotedOpportunityCad: number;
  /**
   *
   * @type {number}
   * @memberof SalesTabData
   */
  openClaims: number;
  /**
   *
   * @type {number}
   * @memberof SalesTabData
   */
  totalClaims: number;
  /**
   *
   * @type {number}
   * @memberof SalesTabData
   */
  additionalChargesCount: number;
}

/**
 * Check if a given object implements the SalesTabData interface.
 */
export function instanceOfSalesTabData(value: object): value is SalesTabData {
  if (!("monthName" in value) || value["monthName"] === undefined) return false;
  if (!("year" in value) || value["year"] === undefined) return false;
  if (!("revenue" in value) || value["revenue"] === undefined) return false;
  if (!("profit" in value) || value["profit"] === undefined) return false;
  if (!("bookedShipments" in value) || value["bookedShipments"] === undefined)
    return false;
  if (!("quotesRan" in value) || value["quotesRan"] === undefined) return false;
  if (
    !("quotedOpportunityCad" in value) ||
    value["quotedOpportunityCad"] === undefined
  )
    return false;
  if (!("openClaims" in value) || value["openClaims"] === undefined)
    return false;
  if (!("totalClaims" in value) || value["totalClaims"] === undefined)
    return false;
  if (
    !("additionalChargesCount" in value) ||
    value["additionalChargesCount"] === undefined
  )
    return false;
  return true;
}

export function SalesTabDataFromJSON(json: any): SalesTabData {
  return SalesTabDataFromJSONTyped(json, false);
}

export function SalesTabDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SalesTabData {
  if (json == null) {
    return json;
  }
  return {
    monthName: json["monthName"],
    year: json["year"],
    revenue: json["revenue"],
    profit: json["profit"],
    bookedShipments: json["bookedShipments"],
    quotesRan: json["quotesRan"],
    quotedOpportunityCad: json["quotedOpportunityCad"],
    openClaims: json["openClaims"],
    totalClaims: json["totalClaims"],
    additionalChargesCount: json["additionalChargesCount"],
  };
}

export function SalesTabDataToJSON(json: any): SalesTabData {
  return SalesTabDataToJSONTyped(json, false);
}

export function SalesTabDataToJSONTyped(
  value?: SalesTabData | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    monthName: value["monthName"],
    year: value["year"],
    revenue: value["revenue"],
    profit: value["profit"],
    bookedShipments: value["bookedShipments"],
    quotesRan: value["quotesRan"],
    quotedOpportunityCad: value["quotedOpportunityCad"],
    openClaims: value["openClaims"],
    totalClaims: value["totalClaims"],
    additionalChargesCount: value["additionalChargesCount"],
  };
}
